import { useMemo } from 'react';

import { useLoginState } from 'src/app/shared/hooks/session';

import { usePromoteFormData } from '../../../formContext/formData';
import { useIsMembershipEligible } from '../useIsMembershipEligible';

export function useSaveBraintreePaymentTemporarily(): boolean {
	const {
		user: { hasPaymentMethod, savedPaymentMethods },
	} = usePromoteFormData();

	const isEligibleForMembership = useIsMembershipEligible();

	const loginState = useLoginState();

	const saveBraintreePaymentTemporarily = useMemo(() => {
		if (!isEligibleForMembership) return false;
		if (loginState === 'IDENTIFIED' && hasPaymentMethod) return false;
		if (loginState === 'AUTHENTICATED' && savedPaymentMethods.find((method) => method.type === 'paypal')) return false;
		return true;
	}, [isEligibleForMembership, loginState, hasPaymentMethod, savedPaymentMethods]);

	return !!saveBraintreePaymentTemporarily;
}
